import {Injectable} from "@angular/core";
import {DEFAULT_PROTOCOL, DEFAULT_SERVER, fontLibrary} from "../common";
import {StoreSelectorsService} from "./store-selectors.service";
import {Compbaser} from "../components/compbaser";
import {Lib} from "../../libs/Lib";

@Injectable()
export class FontLoaderService extends Compbaser {

    private m_fontsScene: Array<string> = [];
    private isFullFeatures: boolean;
    private paintFontsInit = false;
    private readonly fontLibraryUnmodified;
    httpRequests = [];

    constructor(private storeSelector: StoreSelectorsService) {
        super();
        this.fontLibraryUnmodified = fontLibrary;
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
                this.initFonts();
            })
        );
    }

    initFonts() {
        this.m_fontsScene = Object.keys(fontLibrary).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }

    public getFontsScene(): Array<string> {
        return this.m_fontsScene;
    }

    public getFontLibraryUnmodified() {
        return this.fontLibraryUnmodified;
    }

    public loadSingleFont(fontName, callback = null) {
        const u = fontName.replace(/[\s\[\]\-!•™&:.,()`'?]/g, '');
        const url = `${DEFAULT_PROTOCOL}${DEFAULT_SERVER}/TTF/${u}.ttf`;
        const request = new XMLHttpRequest();
        request.addEventListener('readystatechange', (e) => {
            if (request.readyState == 2 && request.status == 200) {
                // Download is being started
            } else if (request.readyState == 3) {
                // Download is under progress
            } else if (request.readyState == 4) {
                // Downloading has finished
                const junction_font = new FontFace(`${fontName}`, `url(${url})`);
                junction_font.load().then((loaded_face) => {
                    document.fonts['add'](loaded_face);
                    document.body.style.fontFamily = `"${fontName}"`;
                    if (callback) callback(true);
                }).catch((error) => {
                    console.log('err loading font ' + url);
                    if (callback) callback(false);
                });
            }
        });
        request.addEventListener('progress', (e) => {
            // console.log(e);
        });
        request.responseType = 'arraybuffer';
        request.open('get', url);
        request.send();
    }
}


// private m_webFontConfig;
// private m_fontsEmbedded;
// if (this.isFullFeatures) {
//   console.log('>>> loading all scene fonts... ' + this.isFullFeatures);
//   this.m_fontsScene = Object.keys(fontLibraryComplete).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
// } else {
//   console.log('>>> loading included only scene fonts... ' + this.isFullFeatures);
//   this.m_fontsScene = Object.keys(fontLibrary).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
// }
// public NOT_USED_initFontsPaint() {
//   if (this.paintFontsInit) {
//     return;
//   }
//   this.paintFontsInit = true;
//   console.log('>>> loading paint fonts...');
//   if (Lib.DevMode()) {
//     this.m_webFontConfig = {google: {families: ['Roboto::latin']}};
//     this.m_fontsEmbedded = 'Roboto'.split(',');
//   } else {
//     this.m_webFontConfig = {
//       google: {
//         families: ['Roboto::latin', 'Oswald::latin', 'Montserrat::latin', 'Raleway::latin', 'Ubuntu::latin', 'Lora::latin', 'Merriweather::latin', 'Arimo::latin', 'Bitter::latin', 'Lobster::latin', 'Dosis::latin', 'Cabin::latin', 'Arvo::latin', 'Abel::latin', 'Inconsolata::latin', 'Signika::latin', 'Pacifico::latin', 'Alegreya::latin', 'Orbitron::latin', 'Anton::latin', 'Quicksand::latin', 'Exo::latin', 'Bangers::latin', 'Chewy::latin', 'Philosopher::latin', 'Righteous::latin', 'Playball::latin', 'Courgette::latin', 'Cinzel::latin', 'Satisfy::latin', 'Amaranth::latin', 'Handlee::latin', 'ABeeZee::latin', 'Tangerine::latin', 'Cookie::latin', 'Limelight::latin', 'Damion::latin', 'Niconne::latin', 'Basic::latin', 'Acme::latin', 'Ultra::latin', 'Alice::latin', 'Overlock::latin', 'Rancho::latin', 'Boogaloo::latin', 'Yellowtail::latin', 'Aclonica::latin', 'Unkempt::latin', 'Gruppo::latin', 'Belleza::latin', 'Allan::latin', 'Capriola::latin', 'Lemon::latin', 'Graduate::latin', 'Rye::latin', 'Baumans::latin', 'Italianno::latin', 'Merienda::latin', 'Englebert::latin', 'Metamorphous::latin', 'Shojumaru::latin', 'Meddon::latin', 'Sniglet::latin', 'Kavoon::latin', 'Sofia::latin', 'Gabriela::latin', 'Aladin::latin', 'Dorsa::latin', 'Redressed::latin', 'Condiment::latin', 'Quintessential::latin', 'Sail::latin', 'Bilbo::latin', 'Stoke::latin', 'Milonga::latin', 'Galindo::latin', 'Offside::latin', 'Fondamento::latin', 'Wellfleet::latin', 'Kenia::latin', 'Chango::latin', 'Julee::latin', 'Astloch::latin', 'Griffy::latin', 'Elsie::latin', 'Miniver::latin', 'Ribeye::latin', 'Piedra::latin', 'Smythe::latin', 'Trochut::latin', 'Ruthie::latin', 'Iceberg::latin', 'Lancelot::latin', 'Devonshire::latin', 'Combo::latin', 'Peralta::latin', 'Sarpanch::latin', 'Akronim::latin']
//       }
//     };
//     this.m_fontsEmbedded = 'Roboto,Oswald,Montserrat,Raleway,Ubuntu,Lora,Merriweather,Arimo,Bitter,Lobster,Dosis,Cabin,Arvo,Abel,Inconsolata,Signika,Pacifico,Alegreya,Orbitron,Anton,Quicksand,Exo,Bangers,Chewy,Philosopher,Righteous,Playball,Courgette,Cinzel,Satisfy,Amaranth,Handlee,ABeeZee,Tangerine,Cookie,Limelight,Damion,Niconne,Basic,Acme,Ultra,Alice,Overlock,Rancho,Boogaloo,Yellowtail,Aclonica,Unkempt,Gruppo,Belleza,Allan,Capriola,Lemon,Graduate,Rye,Baumans,Italianno,Merienda,Englebert,Metamorphous,Shojumaru,Meddon,Sniglet,Kavoon,Sofia,Gabriela,Aladin,Dorsa,Redressed,Condiment,Quintessential,Sail,Bilbo,Stoke,Milonga,Galindo,Offside,Fondamento,Wellfleet,Kenia,Chango,Julee,Astloch,Griffy,Elsie,Miniver,Ribeye,Piedra,Smythe,Trochut,Ruthie,Iceberg,Lancelot,Devonshire,Combo,Peralta,Sarpanch,Akronim'.split(',');
//   }
//   this.m_webFontConfig = {
//     google: {
//       families: ['Roboto::latin', 'Oswald::latin', 'Montserrat::latin', 'Raleway::latin', 'Ubuntu::latin', 'Lora::latin', 'Merriweather::latin', 'Arimo::latin', 'Bitter::latin', 'Lobster::latin', 'Dosis::latin', 'Cabin::latin', 'Arvo::latin', 'Abel::latin', 'Inconsolata::latin', 'Signika::latin', 'Pacifico::latin', 'Alegreya::latin', 'Orbitron::latin', 'Anton::latin', 'Quicksand::latin', 'Exo::latin', 'Bangers::latin', 'Chewy::latin', 'Philosopher::latin', 'Righteous::latin', 'Playball::latin', 'Courgette::latin', 'Cinzel::latin', 'Satisfy::latin', 'Amaranth::latin', 'Handlee::latin', 'ABeeZee::latin', 'Tangerine::latin', 'Cookie::latin', 'Limelight::latin', 'Damion::latin', 'Niconne::latin', 'Basic::latin', 'Acme::latin', 'Ultra::latin', 'Alice::latin', 'Overlock::latin', 'Rancho::latin', 'Boogaloo::latin', 'Yellowtail::latin', 'Aclonica::latin', 'Unkempt::latin', 'Gruppo::latin', 'Belleza::latin', 'Allan::latin', 'Capriola::latin', 'Lemon::latin', 'Graduate::latin', 'Rye::latin', 'Baumans::latin', 'Italianno::latin', 'Merienda::latin', 'Englebert::latin', 'Metamorphous::latin', 'Shojumaru::latin', 'Meddon::latin', 'Sniglet::latin', 'Kavoon::latin', 'Sofia::latin', 'Gabriela::latin', 'Aladin::latin', 'Dorsa::latin', 'Redressed::latin', 'Condiment::latin', 'Quintessential::latin', 'Sail::latin', 'Bilbo::latin', 'Stoke::latin', 'Milonga::latin', 'Galindo::latin', 'Offside::latin', 'Fondamento::latin', 'Wellfleet::latin', 'Kenia::latin', 'Chango::latin', 'Julee::latin', 'Astloch::latin', 'Griffy::latin', 'Elsie::latin', 'Miniver::latin', 'Ribeye::latin', 'Piedra::latin', 'Smythe::latin', 'Trochut::latin', 'Ruthie::latin', 'Iceberg::latin', 'Lancelot::latin', 'Devonshire::latin', 'Combo::latin', 'Peralta::latin', 'Sarpanch::latin', 'Akronim::latin']
//     }
//   };
//   this.m_fontsEmbedded = 'Roboto,Oswald,Montserrat,Raleway,Ubuntu,Lora,Merriweather,Arimo,Bitter,Lobster,Dosis,Cabin,Arvo,Abel,Inconsolata,Signika,Pacifico,Alegreya,Orbitron,Anton,Quicksand,Exo,Bangers,Chewy,Philosopher,Righteous,Playball,Courgette,Cinzel,Satisfy,Amaranth,Handlee,ABeeZee,Tangerine,Cookie,Limelight,Damion,Niconne,Basic,Acme,Ultra,Alice,Overlock,Rancho,Boogaloo,Yellowtail,Aclonica,Unkempt,Gruppo,Belleza,Allan,Capriola,Lemon,Graduate,Rye,Baumans,Italianno,Merienda,Englebert,Metamorphous,Shojumaru,Meddon,Sniglet,Kavoon,Sofia,Gabriela,Aladin,Dorsa,Redressed,Condiment,Quintessential,Sail,Bilbo,Stoke,Milonga,Galindo,Offside,Fondamento,Wellfleet,Kenia,Chango,Julee,Astloch,Griffy,Elsie,Miniver,Ribeye,Piedra,Smythe,Trochut,Ruthie,Iceberg,Lancelot,Devonshire,Combo,Peralta,Sarpanch,Akronim'.split(',');
//
//    function addGoogleFont(FontName) {
//     jQuery("head").append("<link href='https://fonts.googleapis.com/css?family=" + FontName + "' rel='stylesheet' type='text/css'>");
//   }
//    for (let i = 0; i < this.m_fontsEmbedded.length; i++) {
//     const family = this.m_fontsEmbedded[i];
//     addGoogleFont(family);
//   }
// }
// public addGoogleFont(FontName) {
//   jQuery("head").append("<link href='https://fonts.googleapis.com/css?family=" + FontName + "' rel='stylesheet' type='text/css'>");
// }
// public getFontsEmbedded() {
//   return this.m_fontsEmbedded;
// }
// export interface IFont {
//     name: string;
//     styles: Array<string>;
// }

